<template>
    <div>
        <div class="d-flex align-items-center justify-content-center pt-3">
            <div class="d-flex align-items-center text-start text-white px-5">
                <h1 class="text-uppercase text-black fw-bold home-text mx-2 display-header text-center">Classes</h1>
            </div>
        </div>
        <div class="container pt-2">
            <div class="mx-auto text-center" style="max-width: 1000px;">
                <p>Find your fun and take a class with Atlas Improv! Our philosophy emphasizes character-based storytelling, and, through our classes, we
pass it on to our students. Besides being fun, comprehensive, diverse, and dynamic, our classes also build confidence, teamwork,
leadership, and decision-making skills.</p>
            </div>
        </div>
        <div class="shows-btn-group pt-5 pb-5 px-4">
            <a :href="`${$CLASS_URL}`" class="shows-btn-link">
                <div class="btn dark-btn text-uppercase mb-5 text-white w-100"
                    type="button">Register</div>
            </a>
            <a href="#courses" class="shows-btn-link">
                <div class="btn text-uppercase mb-5 text-white w-100"
                    style="background-color: var(--atlas-red);" type="button">Courses</div>
            </a>
        </div>
        <WhatToExpect />

        <!-- Why Atlas Improv? -->
        <!--
        <section class="why-atlas-section py-5">
            <div class="row g-0 align-items-center px-4 px-lg-5">
                <div class="col-12 col-xl-4 d-flex align-items-center justify-content-center pb-4 pb-xl-0">
                    <img src="@/assets/purple_duo.png" class="why-atlas-image" alt="Atlas Improv performers" />
                </div>
                <div class="col-12 col-xl-8 ps-xl-5">
                    <div class="text-center mb-4">
                        <div class="text-uppercase oswald-bold text-white why-atlas-title">Why Atlas Improv?</div>
                    </div>
                    <p class="why-atlas-body">
                        Our philosophy emphasizes character-based storytelling — not just punchlines.
                        You'll join a generous, welcoming community of performers who'll cheer you on
                        and play with you long after the semester ends. Improv builds confidence,
                        listening, public speaking, leadership, and quick thinking — skills that show
                        up at work, in interviews, and in everyday life. Most classes culminate in a
                        class show on our stage, so you graduate with real performance experience and
                        the chance to keep going through Jam, Drop-In, and beyond.
                    </p>
                </div>
            </div>
        </section>
        -->


        <div id="courses"></div>
        <AllClasses />
        <!-- <Carousel /> -->
        <PageSections :sectionId="2" />
        <!-- <div class="container-fluid" style="background-color: black;">
         <div class="row chalk-row">
             <div class="col-md-6 offset-md-3 d-flex flex-column align-items-center justify-content-center">
                 <div class="text-center chalk-outline">
                     <div class="fs-1 text-uppercase text-white"> Take a Class</div>
                     <div class="fs-1 text-uppercase text-white"> With atlas improv</div>
                 </div>
                 <div class="text-white text-center">Atlas Improv's philosophy emphasizes character-based
                     storytelling, and, through our classes, we pass it on to our students. Besides being fun,
                     comprehensive, diverse and dynamic, our classes also build confidence, teamwork, leadership and
                     decision-making skills.</div>
                 <div class="text-white py-3 p text-center"> Every Fall, Spring, and Summer Semester, we typically
                     offer improv Core Class, Advanced Short-form and Long-form classes.</div>
                 <div class="pt-5">
                     <div class="btn ms-2 text-uppercase text-white chalk-btn "
                         style="background-color: #1A95AC; border-radius: 0;" type="button">Register</div>
                 </div>

             </div>

         </div>

     </div>
     <div class="container-fluid" style="background-color:rgb(246,206,55);">
         <div class="row flex-row-reverse">
             <div class="col-md-6">
                 <div class="our-story">
                     <div class='h1 text-uppercase'> Our Story</div>
                     <div class="py-3">Atlas Improv was founded in early 2004 by Mary Parmentier and Bryan Judkins.
                         Their dream was to explore and innovate beyond what was familiar. As managers Parmentier and
                         Judkins sought a creative environment that challenged and fulfilled us artistically. They
                         knew we were capable of more and wanted to push us to new heights. They realized short-form
                         wasn’t enough. In 2004, they Started Atlas Improv. The active mebers of ComedySportz -
                         Madison followed Parmentier to do something new and amazing.</div>
                     <div class="py-3">Today Atlas Improv fosters an expert in each of its players. In story arc,
                         character building, or pure wite, every performer is a master.</div>
                     <div class="btn text-uppercase text-white chalk-btn my-5 orange-back " type="button">Register</div>
                 </div>
             </div>
             <div class="col-md-6">
                 <img :src="`${$API_ASSETS}4b23b7c6-fb4b-44cd-bb1f-f52b097724eb.png`"
                     class="img-fluid w-100 d-md-inline" alt="globe" />
             </div>
         </div>

     </div> -->
        <Footer />

    </div>



</template>

<script>
import { useHead } from '@vueuse/head';
import { useRoute } from 'vue-router';
import PageSections from '@/components/PageSections.vue';
import Footer from '../components/Footer.vue'
import AllClasses from '@/components/AllClasses.vue';
import WhatToExpect from '@/components/WhatToExpect.vue';
// import Carousel from '@/components/Carousel.vue';
export default {
    name: 'Classes',
    setup() {
      const route = useRoute();
      useHead({
        title: route.meta.title || 'Atlas Improv – Classes',
        meta: [
          {
            name: 'description',
            content: route.meta.description || 'Discover and register for improv classes at Atlas Improv in Madison.'
          }
        ]
      });
      return {};
    },
    components: {
        Footer, PageSections, AllClasses, WhatToExpect
    },
};
</script>

<style scoped>
.shows-btn-group {
    display: flex;
    justify-content: center;
    gap: 1rem;
}

/* Why Atlas Improv? section */
.why-atlas-section {
    background-color: var(--site-purple);
}

.why-atlas-title {
    font-size: clamp(2rem, 5vw, 3.5rem);
    letter-spacing: 2px;
    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
}

.why-atlas-image {
    max-height: 600px;
    width: 100%;
    object-fit: contain;
}

.why-atlas-body {
    font-size: 1.05rem;
    line-height: 1.75;
    color: #f0e6f5;
}

@media (min-width: 576px) and (max-width: 1199px) {
    .why-atlas-image {
        max-width: 50%;
    }
}

.shows-btn-link {
    min-width: 180px;
}

@media (max-width: 575px) {
    .shows-btn-link {
        min-width: unset;
        flex: 1;
    }

    .shows-btn-link .btn {
        font-size: 0.7rem;
        padding: 0.375rem 0.5rem;
        width: 100%;
    }
}
</style>
